import { render, staticRenderFns } from "./StockInformationPopover.vue?vue&type=template&id=a5d260ce"
import script from "./StockInformationPopover.vue?vue&type=script&lang=js"
export * from "./StockInformationPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports